// extracted by mini-css-extract-plugin
export default {"comment":"CalculatorPageFooter_comment__hB8JC"};